import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { minorAilments, minorAilmentSteps } from "../../../text/data";
import AccordionItem from "../../../../common/AccordionItem";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import { useDispatch, useSelector } from "react-redux";
import {
  createClinicalService,
  updateSystemSessionApplicationName,
} from "../../../../../redux/modules/clinical-services/actions";
import NewToolTip from "../../../../common/New-ToolTip";
import { calculateAgeYear } from "../../../../../helpers/functions";

const MinorAilmentSymptomType = ({
  setOpenNoSymptomMatchDialog,
  showMinorAilmentTooltip,
  setMinorAilmentsStep,
  setShowMinorAilmentTooltip,
  setAllowAilmentSelection,
  openNoSymptomMatchDialog,
  allowAilmentSelection,
  setMinorAilmentCreated,
  active,
  handleToggle,
  onTreatment,
  onPrevention,
  onContinue,
}) => {
  const dispatch = useDispatch();
  const { clinicalServiceObj, clinicalServiceLocal } = useSelector(
    (state) => state.clinicalService
  );
  const { patient } = useSelector((state) => state.patients);
  const [presentingSymptoms, setPresentingSymptoms] = useState("");
  const [onSymptomChanges, setOnSymptomChanges] = useState("Continue");

  const [openPharmacistConsentDialog, setOpenPharmacistConsentDialog] =
    useState(false);
  const [showEligibilityModal, setShowEligibilityModal] = useState(false);
  const [eligibilityAilmentName, setEligibilityAilmentName] = useState("");
  const [eligibilityPendingIndex, setEligibilityPendingIndex] = useState(null);

  const minorAilmentTitle = Number.isInteger(active)? minorAilments[active] : null;

  const updateClinicalService = () => {
    const selectedSubMenu = (minorAilmentTitle?.title || "").trim();
    dispatch(
      updateSystemSessionApplicationName(
        "Minor Ailments",
        selectedSubMenu || null
      )
    );

    const updatedClinicalServiceObj = {
      ...clinicalServiceLocal, // Spread the existing properties of clinicalServiceObj
      preAssessment: {
        ...clinicalServiceLocal?.preAssessment,
        presentingSymptoms: presentingSymptoms,
        pharmacistAcknowledgeIndicator: true,
      },
      currentStep: 1,
      currentSubStep: 1,
      startDateTime: new Date().toISOString(),
      endDateTime: new Date().toISOString(),
      serviceSteps: disableSpecialPopulationStep(minorAilmentSteps),
    };
    dispatch(
      createClinicalService(
        patient.id,
        "AllergicRhinitis",
        updatedClinicalServiceObj
      )
    );
    setMinorAilmentCreated(true);
  };

  const disableSpecialPopulationStep = (steps) => {
    let showPregnancy = calculateAgeYear(patient.dateOfBirth) >= 12;
    const updatedServiceSteps = steps?.map((step) => ({
      ...step,
      subSteps: step.subSteps.map((subStep) =>
        subStep.name === "Pregnancy"
          ? { ...subStep, show: showPregnancy }
          : subStep
      ),
    }));

    return updatedServiceSteps;
  };

  const handlePresentingSymptomsContinueClick = () => {
    // const updatedClinicalServiceObj = {
    //   ...clinicalServiceLocal, // Spread the existing properties of clinicalServiceObj
    //   preAssessment: {
    //     ...clinicalServiceLocal.preAssessment, // Spread the existing properties of initialAssessment
    //     presentingSymptoms: presentingSymptoms,
    //   },
    // };
    // dispatch({
    //   type: "UPDATE_CLINICAL_SERVICE_LOCAL",
    //   payload: updatedClinicalServiceObj,
    // });
  };

  useEffect(() => {
    onContinue(presentingSymptoms === "" ? 0 : 1);
  }, [presentingSymptoms]);

  const handleTreatment = (index) => {
    const name = minorAilments[index]?.title || "";
    setEligibilityAilmentName(name);
    setEligibilityPendingIndex(index);
    setShowEligibilityModal(true);
    setOpenPharmacistConsentDialog(false);
  };

  const closeEligibilityModal = () => {
    setShowEligibilityModal(false);
    setEligibilityPendingIndex(null);
  };

  const onEligibilityContinue = () => {
    const index = eligibilityPendingIndex;
    setShowEligibilityModal(false);
    setEligibilityPendingIndex(null);
    setAllowAilmentSelection(true);
    if (index === null || index === undefined) return;
    if (minorAilments[index]?.title === "Allergic Rhinitis") {
      setOpenPharmacistConsentDialog(true);
      return;
    }
    if (onTreatment) {
      onTreatment(index);
    }
  };

  const onEligibilityCancel = () => {
    closeEligibilityModal();
    setAllowAilmentSelection(false);
  };

  return (
    <>
      <button
        className="flex items-center gap-2"
        onClick={() => {
          setMinorAilmentsStep(1);
          setAllowAilmentSelection(false);
        }}
      >
        <ChevronLeftIcon className="w-4 h-4 text-teal-300" />
        <h3 className="text-body-md font-semibold text-teal-300 hover:underline">
          Clinical Services
        </h3>
      </button>
      <div
        className="flex items-center gap-3 "
        onMouseLeave={() => setShowMinorAilmentTooltip(false)}
      >
        <h4 className="text-2xl font-bold text-teal-300">Minor Ailments</h4>
        <h4 className="text-body-xl text-teal-300">
          (Minor Ailments - In partnership with medSask
        </h4>
        <div className="flex flex-row">
          <ReactSVG
            src="/icons/information-dark.svg"
            className="w-5"
            data-tooltip-id={"allergic-rhinitis-guidelines"}
          />
          )
          {
            <NewToolTip
              place={"bottom"}
              id={"allergic-rhinitis-guidelines"}
              render={() => (
                <div className="bg-white max-w-[460px]">
                  <div className="flex justify-between bg-gray-20 font-semibold text-md-body text-teal-300 gap-4 p-6">
                    <h2>medSask - Minor Ailments and Self-Care Guidelines</h2>
                  </div>
                  <div className="flex flex-col gap-3 p-6">
                    <div className="text-teal-300 text-sm-body prose-a:underline">
                      <div className=" flex flex-col gap-4">
                        <p>
                          The Guidelines are intended to be used as a tool to
                          aid decision-making when prescribing for certain minor
                          ailments or self-care conditions.
                        </p>
                        <p>
                          The Guidelines are intended solely for educational and
                          informational purposes and are not to be used for
                          diagnostic purposes, and do not replace personal
                          skill, professional judgment, and care of a pharmacist
                          or other healthcare professionals.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            />
          }
        </div>
      </div>
      <div className="grid grid-cols-12 gap-5">
        <div className="col-span-3 rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
          <div className="px-5 py-4 bg-gray-20">
            <h3 className="text-body-lg font-bold text-teal-300">
              Add Presenting Symptom(s)
            </h3>
          </div>
          <div className="flex-1 p-2">
            <textarea
              name="description"
              className="w-full placeholder-gray-800 min-h-full border-[0px] resize-none outline-[0px] focus:outline-[0px] focus:ring-[0px] "
              placeholder="Add description of Presenting Symptom(s)."
              id="description"
              value={presentingSymptoms}
              onChange={(e) => setPresentingSymptoms(e.target.value)}
              onFocus={() => {
                setAllowAilmentSelection(false);
                if (presentingSymptoms !== "") {
                  allowAilmentSelection &&
                    setOnSymptomChanges("Save & Continue");
                }
              }}
            />
          </div>
          {/* <div className="flex justify-end bg-gray-20 pr-3">
            <button
              className={`m-2 h-4 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-300 text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center px-3 py-4 
              ${
                presentingSymptoms === ""
                  ? "pointer-events-none opacity-40"
                  : ""
              }`}
              onClick={() => handlePresentingSymptomsContinueClick()}
            >
              <h3 className="text-body-md font-semibold text-white">
                {onSymptomChanges}
              </h3>
              <ChevronRightIcon className="w-4 ml-2 h-4 text-white" />
            </button>
          </div> */}
        </div>
        <div
          className={`flex flex-col justify-between col-span-6 rounded-[4px] border border-gray-100 h-[636px]`}
          // ${
          //   !allowAilmentSelection &&
          //   "opacity-50 !rounded-[10px] overflow-hidden cursor-not-allowed pointer-events-none"
          // }
        >
          <div className="px-5 py-4 bg-gray-20">
            <h3 className="text-body-lg font-bold text-teal-300">
              Select Minor Ailment{" "}
            </h3>
          </div>
          <div className=" bg-scroll h-[520px] overflow-y-auto scroll-smooth">
            {minorAilments.map((item, index) => (
              <div className="">
                <AccordionItem
                  key={index}
                  id={index}
                  faq={{ ...item, isClaimTooltip: true }}
                  active={active}
                  handleToggle={handleToggle}
                  onTreatment={handleTreatment}
                  onPrevention={onPrevention}
                  isAMR={false}
                  disable={item.disable}
                />
              </div>
            ))}
          </div>
          <div className="flex items-center justify-center px-5 py-4 bg-gray-20 hover:bg-blue-100">
            <button
              className="gap-2"
              onClick={() => setOpenNoSymptomMatchDialog(true)}
            >
              <h2 className="text-body-md font-semibold text-teal-300">
                <u>No Symptoms Match Ailment(s)</u>
              </h2>
            </button>
          </div>
          {/* <div className="flex flex-col gap-4 px-5 pt-1.5 pb-5">
        </div> */}
          <ConfirmationModalNew
            open={openNoSymptomMatchDialog}
            title={"No Symptoms Match Ailment Alert"}
            type={"primary"}
            confirmText={"End Service"}
            content={() => (
              <div className="text-gray-600 text-md-body">
                <p className="font-semibold">
                  Presenting symptoms do not match a minor ailment.
                  <br />
                  Therefore, unable to confirm self diagnosis.
                </p>
                <br />
                <br />
                <span>Stop Assessment</span> <br />
                <span>Refer to Primary Healthcare Provider</span>
              </div>
            )}
            handleClose={() => setOpenNoSymptomMatchDialog(false)}
            onCross={() => setOpenNoSymptomMatchDialog(false)}
            confirmAction={() => {
              setOpenNoSymptomMatchDialog(false);
              setMinorAilmentsStep(1);
              setOnSymptomChanges("Continue");
              setPresentingSymptoms("");
            }}
          />
          <ConfirmationModalNew
            open={showEligibilityModal}
            title="Minor Ailment Eligibility Check"
            type="primary"
            titleClassName="!text-[20px]"
            className="!min-w-[580px]"
            confirmText={"Continue Assessment"}
            cancelText={"Cancel"}
            content={() => (
              <div className="text-gray-800 text-md">
                <p>
                Confirm there is no active prescription for the treatment of {" "}
                  <strong className="text-teal-300">{eligibilityAilmentName}</strong>, including
                  prescriptions to fill, adapt, or refill.
                </p>
                <br />
                <p>Please review eligibility to continue with assessment.</p>
              </div>
            )}
            confirmAction={onEligibilityContinue}
            cancelAction={onEligibilityCancel}
            handleClose={onEligibilityCancel}
            onCross={onEligibilityCancel}
          />
          <ConfirmationModalNew
            open={openPharmacistConsentDialog}
            title={"Pharmacist Acknowledgement/Consent"}
            titleClassName="text-[24px]"
            className="!w-[750px] !max-w-none"
            type={"primary"}
            confirmText={"I Agree"}
            cancelText={"Cancel"}
            content={() => (
              <>
                <ul className="pl-6 list-disc flex flex-col gap-4 text-[18px] text-gray-700">
                  <li>
                    I have the competence and knowledge to engage in prescribing
                    for Minor Ailments.
                  </li>
                  <li>
                    I will apply the clinical evidence and guidelines when
                    prescribing.
                  </li>
                  <li>
                    The selected minor ailment is within the pharmacist's scope
                    of practice.
                  </li>
                  <li>
                    I will write the prescription according to the provisions of
                    the Pharmacy Act.
                  </li>
                </ul>
                <br />
              </>
            )}
            handleClose={() => setOpenPharmacistConsentDialog(false)}
            onCross={() => setOpenPharmacistConsentDialog(false)}
            confirmAction={() => {
              setOpenPharmacistConsentDialog(false);
              updateClinicalService();
            }}
          />
        </div>
        {/* <EligibilityTable /> */}
      </div>
    </>
  );
};

export default MinorAilmentSymptomType;
